import { Box, CloseButton, Text, Title } from "@mantine/core";
import type { ReactNode } from "react";
import classes from "./app-modal.module.css";

type HeaderProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  onClose?: () => void;
  /** Confirm dialogs use 18/650 title */
  confirm?: boolean;
  /** Drawer headers get a bottom border */
  bordered?: boolean;
  closeDisabled?: boolean;
};

/** Shared modal/drawer title row when not using Mantine `title` prop. */
export function AppModalHeader({
  title,
  subtitle,
  onClose,
  confirm = false,
  bordered = false,
  closeDisabled = false,
}: HeaderProps) {
  return (
    <Box className={bordered ? classes.chromeHeaderBordered : classes.chromeHeader}>
      <Box style={{ minWidth: 0, flex: 1 }}>
        {typeof title === "string" ? (
          <Title order={2} className={confirm ? classes.chromeTitleConfirm : classes.chromeTitle}>
            {title}
          </Title>
        ) : (
          title
        )}
        {subtitle ? (
          typeof subtitle === "string" ? (
            <Text className={classes.chromeSubtitle}>{subtitle}</Text>
          ) : (
            <Box className={classes.chromeSubtitle}>{subtitle}</Box>
          )
        ) : null}
      </Box>
      {onClose ? (
        <CloseButton
          className={classes.chromeClose}
          onClick={onClose}
          disabled={closeDisabled}
          aria-label="close"
        />
      ) : null}
    </Box>
  );
}

type FooterProps = {
  children: ReactNode;
  /** Sticky bottom bar (drawers) */
  sticky?: boolean;
};

/** Full-bleed footer with top border — buttons right-aligned, 38px. */
export function ModalFooter({ children, sticky = false }: FooterProps) {
  return <Box className={sticky ? classes.footerSticky : classes.footer}>{children}</Box>;
}
